// How the FAQ import reports (Excel, old documents) are shown: an item is
// `{row | index, field, code, message_params}`.
import { faqMessageParams } from '../../api/faq'

const NOTES = new Set(['duplicate', 'stale_row', 'placeholder_text', 'example_row_skipped', 'image_column_ignored', 'unknown_column'])
export const TONES = {
  info: 'border-slate-200 bg-white',
  note: 'border-amber-200 bg-amber-50',
  error: 'border-red-200 bg-red-50',
}
export const toneOf = (code) => (code === 'updated' ? 'info' : NOTES.has(code) ? 'note' : 'error')

// The sheet's column name of a report field: alt_2 -> "Cách hỏi khác 2", link_url_1 -> "Link 1".
export function fieldLabel(t, field) {
  if (!field) return ''
  const numbered = field.match(/^(alt|link_url|link_label)_(\d+)$/)
  if (numbered) return t(`faq.import.fields.${numbered[1]}`, { n: numbered[2] })
  if (field === 'alts_legacy') return t('faq.import.fields.alt_phrasings')
  return t(`faq.import.fields.${field}`, { defaultValue: field })
}

export const reportMessage = (t, item) => t(`faq.import.report.${item.code}`, {
  ...faqMessageParams(item.message_params),
  defaultValue: t(`faq.errors.${item.code}`, { defaultValue: t('faq.errors.unknown') }),
})
